import { render, staticRenderFns } from "./CheckTeamPersons.vue?vue&type=template&id=396baeec&scoped=true"
import script from "./CheckTeamPersons.vue?vue&type=script&lang=js"
export * from "./CheckTeamPersons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396baeec",
  null
  
)

export default component.exports